import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { updateChatAssigneeFirebase } from '../../../../firebase/privateChat/firebaseActions'
import { ZoomFrame } from '@/components/ui/zoomable-image'

import { getAssetLink } from '../../../../helpers/get-asset-link'
import { getChatTypeFromConversation, getProperStaffUsers } from '../../helpers'

import AssigneeSelector from './AssigneeSelector'

const ChatNavbar = ({
  selectedChat,
  managementUsers,
  currentBuildingId,
  assignedConversationData,
}) => {
  const [assignedUserId, setAssignedUserId] = useState()
  const currentTeamShortcut = getChatTypeFromConversation(selectedChat)

  const assigneeUserToChat = (assigneeId) => {
    setAssignedUserId(assigneeId)
    updateChatAssigneeFirebase(currentBuildingId, selectedChat.channelName, assigneeId)
  }

  useEffect(() => {
    if (selectedChat) {
      const assignedConvData = assignedConversationData.find(
        (conv) => conv.name === selectedChat.channelName,
      )
      if (assignedConvData) {
        setAssignedUserId(assignedConvData.assignee)
      } else {
        setAssignedUserId(null)
      }
    }
  }, [selectedChat, assignedConversationData])

  return (
    <div className="chat-navbar">
      <div className="profile-container">
        <div className="avatar-container">
          <ZoomFrame
            hintSize="2rem"
            src={getAssetLink({ path: 'chitown-avatar/avatar', file: selectedChat.avatar })}
            style={{ borderRadius: '8px', display: 'block' }}
            title={selectedChat.name}
          >
            <img src={getAssetLink({ path: 'chitown-avatar/avatar', file: selectedChat.avatar })} />
          </ZoomFrame>
        </div>
        <div className="user-data-container">
          <div className="name-container">{selectedChat.name}</div>
          <div className="role-container">{selectedChat.phone}</div>
        </div>
      </div>
      {currentTeamShortcut !== 'CUST' && (
        <AssigneeSelector
          selectedId={assignedUserId}
          onChange={assigneeUserToChat}
          options={getProperStaffUsers(currentTeamShortcut, managementUsers)}
          disabled={false}
        />
      )}
    </div>
  )
}

ChatNavbar.propTypes = {
  selectedChat: PropTypes.object,
  managementUsers: PropTypes.array,
  currentBuildingId: PropTypes.number,
  assignedConversationData: PropTypes.arrayOf(PropTypes.object),
}

export default ChatNavbar
